export const CONTACT_OBJECT_TYPE_ID = '0-1';
export const COMPANY_OBJECT_TYPE_ID = '0-2';
export const TICKET_OBJECT_TYPE_ID = '0-5';